import { IAIConfiguration } from "@entities/AIControls/lib/types";
import { api } from "@shared/lib/api";
import {
  BackednResponse,
  IBrandComment,
  IBriefInfluencer,
  IDelPackage,
  IGetFaectValue,
} from "@shared/lib/types";
import {
  BriefNotificationActionType,
  IAddBrandPriceRequest,
  IAddInfluencerDealRequest,
  IAddNewBrandPriceRequest,
  IAddNewBrandPurchaseTargetPriceRequest,
  IBrief,
  IBRIEF_CONFIG_FACET,
  IBriefAiOverviewGenerateResponse,
  IBriefAiOverviewResponse,
  IBriefCreateRequest,
  IBriefDataFields,
  IBriefFacets,
  IBriefForm,
  IBriefInfluencerPurchaseStatusRequest,
  IBriefInflunecerPendingReviewFacets,
  IBriefNotification,
  IBriefOperationsUpdateRequest,
  IBriefPlanningUpdateRequest,
  IBriefPricingUpdateRequest,
  IBriefRequest,
  IBriefResponse,
  IBulkActionRequest,
  IDeleteInfluencerRequest,
  IEditBrandPriceRequest,
  IEditDefaultPricicingPocRequest,
  IInfluencerByAgency,
  ILockDealRequest,
  ILookup,
  ILookupV2,
  INegotiateBrandInfluencerRequest,
  INegotiateInfluencerDealRequest,
  IParseCreatorsCsvRequest,
  IParseCreatorsGoogleSheetRequest,
  IParseEditCreatorsGoogleSheetRequest,
  IPreCheckDeliverablesRequest,
  IPurchaseBrandInfluencerRequest,
  IRejectBrandInfluencerRequest,
  IRemoveDefaultPricicingPocRequest,
  ISharedByAgency,
  IShortListBrandInfluencerRequest,
  ISuggestInfluencerRequest,
  ISuggestInfluencerUsernameRequest,
  ISuggestInfluencerWithPricingRequest,
} from "@shared/lib/types/brief";
import {
  BriefCampaignInf,
  ICampaignPendingReviewActionCount,
  IGetScriptComplianceResponse,
} from "@shared/lib/types/briefCampains";
import {
  IBrandCostRequest,
  IBreifInfIdFacetsResult,
  IBriefDeliverable,
  IBriefDeliverableResponse,
  IBriefInfluencerSearchRequestV2,
  IBriefInfluencerSearchRequestV2WithoutBriefId,
  IBriefInfluencerV2,
  IConfirmationRequest,
  ICreareIBriefDeliverable,
  IDataFieldValue,
  IDecline,
  IDeliverableFacets,
  IEditIBriefDeliverable,
  IFieldConfig,
  IFieldConfigResponse,
  IGetBriefInfluencersV2Response,
  IGetBriefInfluencerV2Response,
  IInfluencerContact,
  IInfluencerCostRequest,
  INegotiateCost,
  INegotiateInfluencerCost,
  ISearchFacets,
  ISkipConfirmationRequest,
} from "@shared/lib/types/briefInfluencerV2";
import {
  IBriefInvoiceSearchRequest,
  ICreateBriefInvoice,
  IEditBriefInvoice,
  IGetBriefInvoiceAggregation,
  IGetBriefInvoiceFacets,
  IGetBriefInvoices,
} from "@shared/lib/types/briefInvoice";
import {
  IBriefLedgerSearchRequest,
  IBriefLedgersSearchRequest,
  ICreateBriefLedger,
  IEditBriefLedger,
  IGetBrandLedgerFacets,
  IGetBriefLedgerAggregation,
  IGetBriefLedgers,
} from "@shared/lib/types/briefLedger";
import {
  IBriefPaymentSearchRequest,
  ICreateBriefPayment,
  IEditBriefPayment,
  IGetBriefPaymentAggregation,
  IGetBriefPaymentFacets,
  IGetBriefPayments,
  IGetBriefTotalAggregation,
} from "@shared/lib/types/briefPayment";
import {
  IAdSegmentRequest,
  ICreateDraftComment,
  IDeleteDraftingComment,
  IDraftingComments,
  IDraftingCommentsReplies,
  IDraftingMediaAssets,
  IDraftingResponse,
  IResolveDraftingComment,
  IVideoCompliance,
} from "@shared/lib/types/drafting";
import {
  IAddSocialMediaBulkRequest,
  IAddSocialMediaBulkResponseRow,
  ILocationFacet,
} from "@shared/lib/types/influencer";
import { IScriptCompliance } from "@shared/lib/types/scripting";
import { BriefInfluencerStage, nextActionToTakeEnum } from "../constants";
import { mapBriefInfluencerSearchParams } from "../mapBriefInfluencerSearchParams";

export class BriefService {
  public static async updateFormV2(data: {
    formV2: string;
    campaignName?: string;
    briefId: string;
  }) {
    const url = "brief/form/v2";
    return (await api
      .put(url, {
        json: {
          formV2: data.formV2,
          name: data.campaignName || undefined,
          briefId: data.briefId,
        },
      })
      .json()) as BackednResponse<IBrief>;
  }
  public static async createBrief(newbrief: IBriefCreateRequest) {
    const url = `brief`;
    return (await api
      .post(url, {
        json: {
          ...newbrief,
        },
      })
      ?.json()) as BackednResponse<IBrief>;
  }
  public static async getBriefs(params: IBriefRequest) {
    const url = `brief/search`;
    const response = (await api
      .post(url, {
        json: {
          ...params,
        },
      })
      .json()) as BackednResponse<IBriefResponse>;
    return response;
  }
  public static async updateBrief(updatedBrief: Partial<IBrief>) {
    const url = `brief`;
    await api.patch(url, {
      json: {
        ...updatedBrief,
      },
    });
  }
  public static async updateBriefDataFields(updatedBrief: IBriefDataFields) {
    const url = `brief/influencer/data-fields`;
    await api.post(url, {
      json: {
        ...updatedBrief,
      },
    });
  }
  public static async updateBriefPricing(
    updatedBrief: Partial<IBriefPricingUpdateRequest>
  ) {
    const url = `brief/pricing`;
    await api.post(url, {
      json: {
        ...updatedBrief,
      },
    });
  }
  public static async updateBriefPlanning(
    updatedBrief: Partial<IBriefPlanningUpdateRequest>
  ) {
    const url = `brief/planning`;
    await api.post(url, {
      json: {
        ...updatedBrief,
      },
    });
  }
  public static async updateBriefOperations(
    updatedBrief: Partial<IBriefOperationsUpdateRequest>
  ) {
    const url = `brief/operations`;
    await api.post(url, {
      json: {
        ...updatedBrief,
      },
    });
  }
  public static async getBriefById(briefId: string) {
    const url = `brief/search/${briefId}`;
    const response = (await api.get(url).json()) as BackednResponse<IBrief>;
    return response;
  }
  public static async getBriefFacets() {
    const url = "brief/search/facets";
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBriefFacets>;
    return response;
  }
  public static async getBriefPlannings(params: IBriefRequest) {
    const url = `brief/search`;
    const response = (await api
      .post(url, {
        json: {
          ...params,
        },
      })
      .json()) as BackednResponse<IBriefResponse>;
    return response;
  }
  public static async getBriefPricings(params: IBriefRequest) {
    const url = `brief/search`;
    const response = (await api
      .post(url, {
        json: {
          ...params,
        },
      })
      .json()) as BackednResponse<IBriefResponse>;
    return response;
  }
  public static async getBriefOperations(params: IBriefRequest) {
    const url = `brief/search`;
    const response = (await api
      .post(url, {
        json: {
          ...params,
        },
      })
      .json()) as BackednResponse<IBriefResponse>;
    return response;
  }

  public static async getBriefInfluencers(
    breifId: string,
    status?: BriefInfluencerStage
  ) {
    const url = `brief/influencer?briefId=${breifId}${
      status ? `&status=${status}` : ""
    }`;
    const response = (await api.get(url).json()) as BackednResponse<
      IBriefInfluencer[]
    >;
    return response;
  }
  public static async getBriefInfluencer(influencerId: string) {
    const url = `brief/influencer/${influencerId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBriefInfluencer>;
    return response;
  }
  public static async suggestInfluencer(data: ISuggestInfluencerRequest) {
    const url = "brief/influencer-v2/suggest-influencer";
    const response = await api.post(url, {
      json: {
        ...data,
      },
    });
    return response.json();
  }
  public static async suggestInfluenceByUsername(
    data: ISuggestInfluencerUsernameRequest
  ) {
    const url = "brief/influencer-v2/suggest-influencer";
    const response = await api.post(url, {
      json: {
        ...data,
      },
    });
    return response.json();
  }
  public static async deleteInfluencer(data: IDeleteInfluencerRequest) {
    const url = "brief/influencer/delete-influencer";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async rejectInfluencer(data: IDeleteInfluencerRequest) {
    const url = "brief/influencer/reject-influencer-deal";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async addInfluencerDeal(data: IAddInfluencerDealRequest) {
    const url = "brief/influencer/add-influencer-deal";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async editInfluencerDeal(data: IAddInfluencerDealRequest) {
    const url = "brief/influencer/edit-influencer-deal";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async negotiateInfluencerDeal(
    data: INegotiateInfluencerDealRequest
  ) {
    const url = "brief/influencer/negotiate-influencer-deal";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }

  public static async lockInfluencerDeal(data: ILockDealRequest) {
    const url = "brief/influencer/lock-influencer-deal";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }

  public static async lookup({
    briefId,
    socialMediaId,
  }: {
    briefId: string;
    socialMediaId: string;
  }) {
    const url = `brief/influencer/lookup`;
    const response = (await api
      .post(url, {
        json: {
          briefId,
          socialMediaObjectIds: [socialMediaId],
        },
      })
      .json()) as BackednResponse<ILookup[]>;
    return response;
  }
  public static async lookupByUsername({
    briefId,
    platform,
    username,
  }: {
    briefId: string;
    platform: string;
    username: string;
  }) {
    const url = `brief/influencer/lookup`;
    const response = (await api
      .post(url, {
        json: {
          briefId,
          socialMediaHandleUsername: [{ platform, username }],
        },
      })
      .json()) as BackednResponse<ILookup[]>;
    return response;
  }
  public static async lookupByUsernameV2({
    briefId,
    platform,
    username,
  }: {
    briefId: string;
    platform: string;
    username: string;
  }) {
    const url = `brief/influencer-v2/lookup`;
    const response = (await api
      .post(url, {
        json: {
          briefId,
          socialMediaHandleUsername: [{ platform, username }],
        },
      })
      .json()) as BackednResponse<ILookupV2[]>;
    return response;
  }
  public static async suggestInfluencerBrand(data: IDeleteInfluencerRequest) {
    const url = "brief/influencer/suggest-influencer-brand";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async getBriefInlfuencerFacets() {
    return (await api
      .get("brief/influencer/facets")
      .json()) as BackednResponse<IGetFaectValue>;
  }

  public static async getBriefConfigFacets() {
    return (await api
      .get("brief/search/data-fields/facets")
      .json()) as BackednResponse<IBRIEF_CONFIG_FACET[]>;
  }

  public static async addBrandPrice(data: IAddBrandPriceRequest) {
    const url = "brief/influencer/add-brand-price";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async editBrandPrice(data: IEditBrandPriceRequest) {
    const url = "brief/influencer/edit-brand-price";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async addNewBrandPrice(data: IAddNewBrandPriceRequest) {
    const url = "brief/influencer/add-new-brand-price";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async shortListBrandInfluencer(
    data: IShortListBrandInfluencerRequest
  ) {
    const url = "brief/influencer/ext/shortlist-influencer";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async rejectBrandInfluencer(
    data: IRejectBrandInfluencerRequest
  ) {
    const url = "brief/influencer/ext/reject-influencer";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async purchaseBrandInfluencer(
    data: IPurchaseBrandInfluencerRequest
  ) {
    const url = "brief/influencer/ext/purchase-influencer";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async negotiateBrandInfluencer(
    data: INegotiateBrandInfluencerRequest
  ) {
    const url = "brief/influencer/ext/negotiate-influencer";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async addNewBrandPurchaseTargetPrice(
    data: IAddNewBrandPurchaseTargetPriceRequest
  ) {
    const url = "brief/influencer/add-new-purchase-target-price";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }

  public static async getBriefLedgers(dataRequest: IBriefLedgerSearchRequest) {
    const searchParams = new URLSearchParams();

    if (dataRequest.searchQuery)
      searchParams.append("searchQuery", dataRequest.searchQuery);
    if (dataRequest.briefId)
      searchParams.append("briefId", dataRequest.briefId);
    if (dataRequest.type?.length)
      searchParams.append("type", dataRequest.type.join("$$"));
    if (dataRequest.subType?.length)
      searchParams.append("subType", dataRequest.subType.join("$$"));
    if (dataRequest.billingId?.length)
      searchParams.append("billingId", dataRequest.billingId.join("$$"));
    if (dataRequest.pageNo)
      searchParams.append("pageNo", dataRequest.pageNo.toString());
    if (dataRequest.limit)
      searchParams.append("limit", dataRequest.limit.toString());

    const url = `billing/brand/ledger?${searchParams.toString()}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefLedgers>;
    return response;
  }

  public static async getBriefsLedgers(
    dataRequest: IBriefLedgersSearchRequest
  ) {
    const url = `billing/brand/ledger/search`;
    const response = (await api
      .post(url, {
        json: {
          ...dataRequest,
          accountingFillingStatus: ["Unbilled"],
        },
      })
      .json()) as BackednResponse<IGetBriefLedgers>;
    return response;
  }

  public static async getBriefLedgerFacets(briefId: string) {
    const url = `billing/brand/ledger/facets?briefId=${briefId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBrandLedgerFacets>;
    return response;
  }

  public static async createBriefLedger(data: ICreateBriefLedger) {
    const url = "billing/brand/ledger";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }

  public static async editBriefLedger(data: IEditBriefLedger) {
    const url = "billing/brand/ledger";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async getBriefInvoices(
    dataRequest: IBriefInvoiceSearchRequest
  ) {
    const searchParams = new URLSearchParams();

    if (dataRequest.searchQuery)
      searchParams.append("searchQuery", dataRequest.searchQuery);
    if (dataRequest.isUrl?.length && !dataRequest.isUrl.includes("All"))
      searchParams.append(
        "isUrl",
        dataRequest.isUrl.includes("Yes") ? "true" : "false"
      );
    if (dataRequest.briefId)
      searchParams.append("briefId", dataRequest.briefId);
    if (dataRequest.type?.length)
      searchParams.append("type", dataRequest.type.join("$$"));
    if (dataRequest.subType?.length)
      searchParams.append("subType", dataRequest.subType.join("$$"));
    if (dataRequest.billingId?.length)
      searchParams.append("billingId", dataRequest.billingId.join("$$"));
    if (dataRequest.pageNo)
      searchParams.append("pageNo", dataRequest.pageNo.toString());
    if (dataRequest.limit)
      searchParams.append("limit", dataRequest.limit.toString());
    if (dataRequest.createdAtFrom)
      searchParams.append("createdAtFrom", dataRequest.createdAtFrom);
    if (dataRequest.createdAtTo)
      searchParams.append("createdAtTo", dataRequest.createdAtTo);

    const url = `billing/invoices/brand?${searchParams.toString()}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefInvoices>;
    return response;
  }

  public static async getBriefInvoiceFacets(briefId: string) {
    const url = `billing/invoices/brand/facets?briefId=${briefId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefInvoiceFacets>;
    return response;
  }

  public static async createBriefInvoice(data: ICreateBriefInvoice) {
    const url = "billing/invoices/brand";
    const { briefId, ...rest } = data;
    await api.post(url, {
      json: {
        createFrom: {
          briefId,
        },
        ...rest,
      },
    });
  }

  public static async editBriefInvoice(data: IEditBriefInvoice) {
    const url = "billing/invoices/brand/";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async getBriefPayments(
    dataRequest: IBriefPaymentSearchRequest
  ) {
    const searchParams = new URLSearchParams();

    if (dataRequest.searchQuery)
      searchParams.append("searchQuery", dataRequest.searchQuery);
    if (dataRequest.briefId)
      searchParams.append("briefId", dataRequest.briefId);
    if (dataRequest.type?.length)
      searchParams.append("type", dataRequest.type.join("$$"));
    if (dataRequest.billingId?.length)
      searchParams.append("billingId", dataRequest.billingId.join("$$"));
    if (dataRequest.pageNo)
      searchParams.append("pageNo", dataRequest.pageNo.toString());
    if (dataRequest.limit)
      searchParams.append("limit", dataRequest.limit.toString());
    if (dataRequest.createdAtFrom)
      searchParams.append("createdAtFrom", dataRequest.createdAtFrom);
    if (dataRequest.createdAtTo)
      searchParams.append("createdAtTo", dataRequest.createdAtTo);

    const url = `billing/brand/payments?${searchParams.toString()}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefPayments>;
    return response;
  }

  public static async getBriefPaymentFacets() {
    const url = `billing/brand/payments/facets`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefPaymentFacets>;
    return response;
  }

  public static async createBriefPayment(data: ICreateBriefPayment) {
    const url = "billing/brand/payments";

    await api.post(url, {
      json: {
        ...data,
      },
    });
  }

  public static async editBriefPayment(data: IEditBriefPayment) {
    const url = "billing/brand/payments/";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async getBriefPaymentAggregation(briefId: string) {
    const response = (await api
      .get(`billing/brand/payments/aggregation?briefId=${briefId}`)
      .json()) as BackednResponse<IGetBriefPaymentAggregation>;
    return response;
  }

  public static async getBriefLedgerAggregation(briefId: string) {
    const response = (await api
      .get(`billing/brand/ledger/aggregation?briefId=${briefId}`)
      .json()) as BackednResponse<IGetBriefLedgerAggregation>;
    return response;
  }

  public static async getBriefInvoicesAggregation(briefId: string) {
    const response = (await api
      .get(`billing/invoices/brand/aggregation?briefId=${briefId}`)
      .json()) as BackednResponse<IGetBriefInvoiceAggregation>;
    return response;
  }

  // Brief Influencer V2 Methods
  public static async getBriefInfluencersV2(
    params: IBriefInfluencerSearchRequestV2
  ) {
    const url = `brief/influencer-v2/search`;
    const response = (await api
      .post(url, {
        json: mapBriefInfluencerSearchParams(params),
      })
      .json()) as BackednResponse<IGetBriefInfluencersV2Response>;
    return response;
  }
  public static async getBriefInfluencersV2WithoutBriefId(
    params: IBriefInfluencerSearchRequestV2WithoutBriefId
  ) {
    const url = `brief/influencer-v2/search`;
    const response = (await api
      .post(url, {
        json: {
          ...params,
        },
      })
      .json()) as BackednResponse<IGetBriefInfluencersV2Response>;
    return response;
  }

  public static async getBriefInfluencerV2(influencerId: string) {
    const url = `brief/influencer-v2/search/${influencerId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefInfluencerV2Response>;
    return response;
  }

  public static async getBriefInfluencerV2Facets(
    influencerId: string,
    socialMediaId?: string
  ) {
    const url = `brief/influencer-v2/facets/influencer`;
    const response = (await api
      .post(url, {
        json: {
          influencerIds: influencerId ? [influencerId] : undefined,
          socialMediaObjectIds: socialMediaId ? [socialMediaId] : undefined,
        },
      })
      .json()) as BackednResponse<IBreifInfIdFacetsResult>;
    return response;
  }
  public static async getBriefInfluencerV2InfId(
    influencerId?: string,
    socialMediaObjectIds?: string[],
    brandIds?: string[],
    mainStatus?: string[]
  ) {
    const url = `brief/influencer-v2/search`;
    const response = (await api
      .post(url, {
        json: {
          influencerIds: influencerId ? [influencerId] : undefined,
          socialMediaObjectIds,
          brandIds,
          mainStatus,
          page: 1,
          limit: 1000,
        },
      })
      .json()) as BackednResponse<IGetBriefInfluencersV2Response>;
    return response;
  }

  // Brief Deliverable Methods
  public static async getBriefDeliverable(deliverableId: string) {
    const url = `brief/influencer-v2/deliverable/v2/${deliverableId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBriefDeliverableResponse>;
    return response;
  }
  public static async getBriefDeliverables(briefId: string) {
    const url = `brief/influencer-v2/deliverable/v2?briefId=${briefId}`;
    const response = (await api.get(url).json()) as BackednResponse<
      IBriefDeliverableResponse[]
    >;
    return response;
  }

  public static async createBriefDeliverable(data: ICreareIBriefDeliverable) {
    const url = "brief/influencer-v2/deliverable/v2";
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async attachBriefDeliverable(
    briefInfluencerIds: string[],
    deliverableV2Id: string,
    resetCost?: boolean
  ) {
    const url = "brief/influencer-v2/deliverable/v2/attach";
    await api.put(url, {
      json: {
        briefInfluencerIds,
        deliverableV2Id,
        resetCost,
      },
    });
  }

  public static async preCheckDeliverables(
    params: IPreCheckDeliverablesRequest
  ) {
    const url = `brief/influencer-v2/deliverable/v2/attach/pre-check`;
    const response = (await api
      .put(url, {
        json: {
          ...params,
          filterParams: mapBriefInfluencerSearchParams(params.filterParams),
        },
      })
      .json()) as BackednResponse<
      {
        status: "failed" | "success" | "warning";
        reason: string;
        briefInfluencerId: string;
        briefInfluencer: IBriefInfluencerV2;
      }[]
    >;
    return response;
  }

  public static async updateBriefDeliverable(data: IEditIBriefDeliverable) {
    const url = "brief/influencer-v2/deliverable/v2";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async addInfluencerPrimaryContact(
    data: IInfluencerContact,
    briefInfluencerId: string
  ) {
    const { agency, ...rest } = data;
    const url = "brief/influencer-v2/attach-primary-contact";
    const response = (await api
      .put(url, {
        json: {
          primaryContact: { ...rest, agency: agency?._id },
          briefInfluencerId,
        },
      })
      .json()) as BackednResponse<IBriefInfluencerV2>;
    return response;
  }
  public static async addIninitalInfluencerCost(data: IInfluencerCostRequest) {
    const url = "brief/influencer-v2/add-influencer-initial-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async addInfluencerCost(data: IInfluencerCostRequest) {
    const url = "brief/influencer-v2/add-new-influencer-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async editInfluencerCost(data: IInfluencerCostRequest) {
    const url = "brief/influencer-v2/edit-influencer-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async addIninitalBrandCost(data: IBrandCostRequest) {
    const url = "brief/influencer-v2/add-brand-initial-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async addBrandCost(data: IBrandCostRequest) {
    const url = "brief/influencer-v2/add-new-brand-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async editBrandCost(data: IBrandCostRequest) {
    const url = "brief/influencer-v2/edit-brand-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async negotiateCost(data: INegotiateCost) {
    const url = "brief/influencer-v2/negotiate-cost";
    return (await api
      .put(url, {
        json: {
          ...data,
        },
      })
      .json()) as BackednResponse<IBriefInfluencerV2>;
  }
  public static async negotiateInfluencerCost(data: INegotiateInfluencerCost) {
    const url = "brief/influencer-v2/negotiate-influencer-cost";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async sendConfirmation(data: IConfirmationRequest) {
    const url = "brief/influencer-v2/send-confirmation";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async requestPrice(briefInfluencerIds: string[]) {
    const url = "brief/influencer-v2/request-price";
    await api.put(url, {
      json: {
        briefInfluencerIds,
      },
    });
  }
  public static async purchaseInfluencer(briefInfluencerIds: string[]) {
    const url = "brief/influencer-v2/purchase";
    const response = (await api
      .put(url, {
        json: {
          briefInfluencerIds,
        },
      })
      .json()) as BackednResponse<{
      nextActionToTake: nextActionToTakeEnum;
      result: {
        status: string;
        reason: string;
        briefInfluencer: IBriefInfluencerV2;
      }[];
    }>;
    return response;
  }
  public static async declineBrand(data: IDecline) {
    const url = "brief/influencer-v2/cancel";
    await api.put(url, {
      json: {
        ...data,
        cancelledBy: "Brand",
      },
    });
  }

  public static async skipConfirmationMail(data: ISkipConfirmationRequest) {
    const url = "brief/influencer-v2/skip-confirmation";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async declineInfluencer(data: IDecline) {
    const url = "brief/influencer-v2/cancel";
    await api.put(url, {
      json: {
        ...data,
        cancelledBy: "Influencer",
      },
    });
  }
  public static async deleteInfluencerV2(briefInfluencerIds: string[]) {
    const url = "brief/influencer-v2/delete-influencer";
    await api.put(url, {
      json: {
        briefInfluencerIds,
      },
    });
  }
  public static async resendConfirmation(briefInfluencerIds: string[]) {
    const url = "brief/influencer-v2/resend-confirmation";
    await api.put(url, {
      json: {
        briefInfluencerIds,
      },
    });
  }
  public static async purchaseNonProfitable(briefInfluencerId: string) {
    const url = "brief/influencer-v2/non-profitable-purchase";
    await api.put(url, {
      json: {
        briefInfluencerId,
      },
    });
  }

  public static async getBriefInfluencerSearchFacets(
    briefId: string,
    status?: string
  ) {
    const url = `brief/influencer-v2/facets?briefId=${briefId}${status ? `&status=${status}` : ""}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<ISearchFacets>;
    return response;
  }

  public static async getBriefInfluencerPendingReviewFacets({
    briefId,
    status,
    statuses,
    isShortListed,
  }: {
    briefId: string;
    status?: string;
    statuses?: string[];
    isShortListed?: boolean;
  }) {
    const url = `brief/influencer-v2/facets/pending-review?briefId=${briefId}${status ? `&status=${status}` : ""}${statuses ? `&statuses=${statuses.join(",")}` : ""}${isShortListed !== undefined ? `&isShortlisted=${isShortListed}` : ""}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBriefInflunecerPendingReviewFacets>;
    return response;
  }
  public static async getBriefInfluencerSearchFacetsWithoutBriefId(
    statuses: string[]
  ) {
    const url = `brief/influencer-v2/facets?statuses=${statuses.join("$$")}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<ISearchFacets>;
    return response;
  }

  public static async getBriefInfluencerSearchFacetsBystatus(
    briefId: string,
    status: string
  ) {
    const url = `brief/influencer-v2/facets?briefId=${briefId}&status=${status}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<ISearchFacets>;
    return response;
  }

  public static async getBriefInfluencerDeliverableFacets(briefId: string) {
    const url = `brief/influencer-v2/deliverable/v2/facets?briefId=${briefId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IDeliverableFacets>;
    return response;
  }
  public static async attachReport(
    briefId: string,
    updateForIntervalHourFrequency: number,
    updateTillDate: string
  ) {
    const url = `brief/attach-report`;
    await api
      .patch(url, {
        json: {
          briefId,
          updateForIntervalHourFrequency,
          updateTillDate,
        },
      })
      .json();
  }

  public static async getBriefDataFields(briefId: string) {
    const url = `brief/search/data-fields/v3/facets?briefId=${briefId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IFieldConfigResponse>;
    return response;
  }

  public static async createBriefDataFieldsV2(
    briefId: string,
    customFieldsV2: IFieldConfig
  ) {
    const url = `brief/custom-fields`;
    await api.post(url, {
      json: {
        briefId,
        customFieldsV2,
      },
    });
  }

  public static async editDataFieldV2Data(
    briefInfluencerId: string,
    dataField: { [key: string]: IDataFieldValue }
  ) {
    const url = `brief/influencer-v2/data-fields`;
    const response = (await api
      .post(url, {
        json: {
          briefInfluencerId,
          dataFields: { ...dataField },
        },
      })
      .json()) as BackednResponse<IBriefInfluencerV2>;
    return response;
  }

  public static async editBriefNotes(data: {
    briefInfluencerId: string;
    agencySharedBrandNotes?: string;
    brandNotes?: string;
  }) {
    const url = "brief/influencer-v2/notes";
    const response = (await api
      .put(url, {
        json: {
          ...data,
        },
      })
      .json()) as BackednResponse<IBriefInfluencerV2>;
    return response;
  }
  public static async toggleBriefDataFieldV2(
    briefId: string,
    brandId: string,
    visibleBrandCustomFieldsV2?: IFieldConfig[],
    visibleBrandPerformanceFieldsV2?: IFieldConfig[],
    dataFieldsV2?: IFieldConfig[],
    visibleBriefTableColumns?: string[]
  ) {
    const url = `brief`;
    const response = (await api
      .patch(url, {
        json: {
          briefId,
          brandId,
          dataFieldsV2,
          visibleBrandCustomFieldsV2,
          visibleBrandPerformanceFieldsV2,
          visibleBriefTableColumns,
        },
      })
      .json()) as BackednResponse<IBrief>;
    return response;
  }

  public static async syncGoogleSheet(
    briefId: string,
    type: "pricing" | "accountManager" | "addCreators" | "editCreators"
  ) {
    const url = `brief/sheets/sync?briefId=${briefId}&type=${type}`;
    const response = (await api.get(url).json()) as BackednResponse<IBrief>;
    return response;
  }

  public static async downloadBriefXlsx(
    briefId: string,
    type: "addCreators" | "editCreators" | "accountManager"
  ) {
    const url = `brief/xlsx/download?briefId=${briefId}&type=${type}`;
    const response = await api.get(url, {
      headers: {
        accept:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
    });
    const blob = await response.blob();
    const disposition = response.headers.get("content-disposition");
    const utfName = disposition?.match(/filename\*=UTF-8''([^;]+)/i)?.[1];
    const asciiName = disposition?.match(/filename="?([^"]+)"?/i)?.[1];
    const filename = utfName
      ? decodeURIComponent(utfName)
      : asciiName || `${type}.xlsx`;

    return { blob, filename };
  }

  public static async parseCreatorsCsv(payload: IParseCreatorsCsvRequest) {
    const url = `brief/influencer-v2/parse-add-brief-influencers-csv`;
    const response = (await api
      .post(url, {
        json: {
          briefId: payload.briefId,
          csv: payload.csv,
        },
      })
      .json()) as BackednResponse<IParseCreatorsGoogleSheetRequest[]>;
    return response;
  }
  public static async parseEditCreatorsCsv(payload: IParseCreatorsCsvRequest) {
    const url = `brief/influencer-v2/parse-edit-brief-influencers-csv`;
    const response = (await api
      .post(url, { json: payload })
      .json()) as BackednResponse<IParseEditCreatorsGoogleSheetRequest[]>;
    return response;
  }

  public static async bulkUploadInfluencerBriefs(
    inputFileUrl: string,
    briefId: string
  ) {
    const url = `download/uploadBriefInfluencers`;
    await api.post(url, {
      json: {
        inputFileUrl,
        briefId,
      },
    });
  }

  public static async getBriefTotalAggregation(briefId: string) {
    const url = `billing/brand/aggregation?briefId=${briefId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IGetBriefTotalAggregation>;
    return response;
  }

  public static async assignPricingPoc(
    briefInfluencerId: string[],
    assignedToUserId: string
  ) {
    const url = `brief/influencer-v2/assign-pricing-poc`;
    await api.put(url, {
      json: {
        briefInfluencerId,
        assignedToUserId,
      },
    });
  }

  public static async askInfluencerCommercial(
    briefInfluencerId: string,
    targetInfluencerCost?: number
  ) {
    const url = `brief/influencer-v2/ask-influencer-commericals`;
    const response = await api.put(url, {
      json: { askTo: [{ briefInfluencerId, targetInfluencerCost }] },
    });
    return response.json();
  }
  public static async askInfluencerCommercialBulk(
    values: { briefInfluencerId: string; targetInfluencerCost?: number }[]
  ) {
    const url = `brief/influencer-v2/ask-influencer-commericals`;
    const response = await api.put(url, {
      json: { askTo: values },
    });
    return response.json();
  }
  public static async negotiateInfluencerCommercial(
    briefInfluencerId: string,
    targetInfluencerCost?: number
  ) {
    const url = `brief/influencer-v2/ask-new-influencer-commericals`;
    const response = await api.put(url, {
      json: {
        askTo: [{ briefInfluencerId, targetInfluencerCost }],
      },
    });
    return response.json();
  }

  public static async setBrandFavourite(briefInfluencerIds: string[]) {
    const url = "brief/influencer-v2/mark-brand-favourite";
    await api.put(url, {
      json: {
        briefInfluencerIds,
      },
    });
  }
  public static async removeBrandFavourite(briefInfluencerIds: string[]) {
    const url = "brief/influencer-v2/mark-brand-unfavourite";
    await api.put(url, {
      json: {
        briefInfluencerIds,
      },
    });
  }
  public static async updatePaymentTerms(data: {
    briefInfluencerId: string;
    paymentTerms: string;
  }) {
    const url = "brief/influencer-v2/payment-terms";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }
  public static async updateEstView(data: {
    briefInfluencerId: string;
    estViews: number;
  }) {
    const url = "brief/influencer-v2/est-views";
    await api.put(url, {
      json: {
        ...data,
      },
    });
  }

  public static async setDefaultDeliverable(data: {
    briefId: string;
    deliverableV2Id: string;
  }) {
    const url = "brief/add-default-deliverable-v2";
    await api.patch(url, {
      json: {
        ...data,
      },
    });
  }

  public static async toggleAgencySharing(data: {
    briefId: string;
    shareEnabled: boolean;
  }) {
    const url = "brief/toggle-agency-sharing";
    await api.patch(url, {
      json: {
        ...data,
      },
    });
  }

  public static async shareWithAgency(data: {
    briefId: string;
    agencyId: string;
    shareWithAgency: boolean;
  }) {
    const url = "brief/share-with-agency";
    await api.patch(url, {
      json: {
        ...data,
      },
    });
  }

  public static async influencersSharedByAgency(
    briefId: string,
    search: string,
    groupByAgency: boolean,
    status: string,
    signal: AbortSignal
  ) {
    const params = new URLSearchParams();
    if (search) {
      params.append("searchQuery", search);
    }
    params.append("groupByAgencyId", groupByAgency.toString());
    params.append("status", status);
    params.append("briefId", briefId);
    const queryString = params.toString();
    const url = `brief/influencer-suggest/search?${queryString}`;
    let response;
    if (groupByAgency) {
      response = (await api.get(url, { signal }).json()) as BackednResponse<
        ISharedByAgency[]
      >;
    } else {
      response = (await api.get(url, { signal }).json()) as BackednResponse<
        IInfluencerByAgency[]
      >;
    }
    return response;
  }

  public static async approveInfluencerSharedByAgency(data: {
    briefInfluencerSuggestionIds: string[];
  }) {
    const url = `brief/influencer-suggest/approve`;
    await api.post(url, {
      json: {
        ...data,
      },
    });
  }
  public static async getBriefLotFacets(briefId: string) {
    const url = `brief/influencer-v2/purchase-lots/search/facets`;
    const response = (await api
      .post(url, { json: { briefId } })
      .json()) as BackednResponse<{
      Pending: number;
    }>;
    return response;
  }
  public static async updateForm(data: {
    form: Partial<IBriefForm>;
    campaignName?: string;
    briefId: string;
  }) {
    const url = "brief/form";
    const response = (await api
      .put(url, {
        json: {
          form: {
            ...data.form,
          },
          name: data.campaignName || undefined,
          briefId: data.briefId,
        },
      })
      .json()) as BackednResponse<IBrief>;
    return response;
  }
  public static async getLocationFacets(location?: string) {
    const url = `influencer/facets/location?location=${location}`;

    const users = (await api.get(url).json()) as BackednResponse<
      ILocationFacet[]
    >;

    return users;
  }
  public static async createBriefBulkDeliverables(data: {
    bulkDeliverables: IDelPackage[];
    briefId: string;
  }) {
    const url = "brief/influencer-v2/deliverables/v2";
    return (await api
      .post(url, {
        json: {
          ...data,
        },
      })
      .json()) as BackednResponse<
      {
        briefId: string;
        deliverableV2: IBriefDeliverable;
        deliverableV2Id: string;
        status: string;
      }[]
    >;
  }

  public static async suggestInCampaignIwithPricing(
    data: ISuggestInfluencerWithPricingRequest
  ) {
    const url = "brief/influencer-v2/copy";
    return (await api
      .put(url, {
        json: {
          ...data,
        },
      })
      ?.json()) as BackednResponse<{
      data: {
        socialMediaObjectId: string;
        status: "failed" | "success";
        reasonType?:
          "Something-Went-Wrong" | "Already-In-Brief" | "Cannot-Find-Contact";
        reason?: string;
        oldBriefInfluencer?: IBriefInfluencerV2;
        briefInfluencer?: IBriefInfluencerV2;
        error?: Error;
      }[];
    }>;
  }

  public static async getDrafting(draftingId: string) {
    const url = `drafting/?draftingId=${draftingId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IDraftingResponse>;
    return response;
  }
  public static async createDraftingComment(data: ICreateDraftComment) {
    const url = "drafting/comment";
    return (await api
      .post(url, { json: { ...data } })
      .json()) as BackednResponse<{
      comment: IDraftingComments;
      clientCommentId?: string;
    }>;
  }
  public static async replyToDraftingComment(data: IDraftingCommentsReplies) {
    const url = "drafting/reply";
    return (await api
      .post(url, { json: { ...data } })
      .json()) as BackednResponse<{
      reply: IDraftingCommentsReplies;
      clientReplyId?: string;
    }>;
  }

  public static async resolveDraftingComment(data: IResolveDraftingComment) {
    const url = "drafting/comment";
    return (await api
      .put(url, { json: { ...data } })
      .json()) as BackednResponse<{
      comment: IDraftingComments;
    }>;
  }
  public static async generateVideoCompliance(data: IVideoCompliance) {
    const url = "drafting/ai/generate-video-compilance-check";
    await api.post(url, { json: { ...data } });
  }

  public static async generateFeedbackSummary(data: IVideoCompliance) {
    const url = "drafting/ai/generate-feedback-summary";
    await api.post(url, { json: { ...data } });
  }

  public static async getMediaAssets(data: IVideoCompliance) {
    const url = "drafting/media-assets";
    const params = new URLSearchParams();
    params.append("draftingId", data.draftingId);
    params.append("draftingVersionId", data.draftingVersionId);
    params.append("mediaAssetId", data.mediaAssetId);

    const queryKey = params.toString();

    return (await api
      .get(`${url}?${queryKey}`)
      .json()) as BackednResponse<IDraftingMediaAssets>;
  }

  public static async addAdSegments(data: IAdSegmentRequest) {
    const url = "drafting/ad-segments";
    return await api.post(url, {
      json: { ...data },
    });
  }

  public static async generateScriptingCompliance(data: IScriptCompliance) {
    const url = "scripting/ai/generate-compilance-check";
    await api.post(url, { json: { ...data } });
  }

  public static async generateScriptingFeedbackSummary(
    data: IScriptCompliance
  ) {
    const url = "scripting/ai/generate-feedback-summary";
    await api.post(url, { json: { ...data } });
  }

  public static async getScriptingCompliance(data: IScriptCompliance) {
    const url = "scripting/ai";
    const params = new URLSearchParams();
    params.append("scriptId", data.scriptId);

    const queryKey = params.toString();

    return (await api
      .get(`${url}?${queryKey}`)
      .json()) as BackednResponse<IGetScriptComplianceResponse>;
  }

  public static async deleteDraftingComment(data: IDeleteDraftingComment) {
    const url = "drafting/comment";
    await api.delete(url, { json: { ...data } });
  }
  public static async addComment(payload: {
    briefInfluencerId: string;
    text: string;
    clientCommentId: string;
  }) {
    return (await api
      .post("brief/influencer-v2/brand-comment", {
        json: {
          ...payload,
        },
      })
      .json()) as BackednResponse<{
      comment: IBrandComment;
      clientCommentId?: string;
    }>;
  }

  public static async deleteComment(payload: {
    commentId: string;
    briefInfluencerId: string;
  }) {
    return (await api
      .delete("brief/influencer-v2/brand-comment", {
        json: {
          ...payload,
        },
      })
      .json()) as BackednResponse<{
      comment: IBrandComment;
      clientCommentId?: string;
    }>;
  }

  public static async markCommentAsRead(payload: {
    briefInfluencerId: string;
    commentIds: string[];
  }) {
    const url = `brief/influencer-v2/brand-comment/read`;
    return await api.post(url, {
      json: {
        ...payload,
      },
    });
  }

  public static async updateBriefOrganisationAllocation(
    briefId: string,
    brandOrganisationManagers: string[]
  ) {
    const url = `brief/edit-brand-organisation-managers`;
    const response = (await api
      .patch(url, {
        json: {
          briefId,
          brandOrganisationManagers,
        },
      })
      .json()) as BackednResponse<IBrief>;
    return response;
  }

  public static async notifyCreatorsAdd(briefId: string) {
    const url = `notification/brief/creators-added`;
    return api.post(url, {
      json: {
        briefId,
      },
    });
  }
  public static async notifyCreatorsCostAdd(briefId: string) {
    const url = `notification/brief/creator-cost-added`;
    return api.post(url, {
      json: {
        briefId,
      },
    });
  }
  public static async notifyNegotiationCompleted(briefId: string) {
    const url = `notification/brief/negotiations-completed`;
    return api.post(url, {
      json: {
        briefId,
        noOfCreatorsNegotiated: 0,
      },
    });
  }

  public static async addSocialMediaBulk(request: IAddSocialMediaBulkRequest) {
    const response = (await api
      .post(`social-media/bulk`, {
        json: request,
      })
      .json()) as BackednResponse<IAddSocialMediaBulkResponseRow[]>;
    return response;
  }

  public static async editDefaultPricicingPoc(
    data: IEditDefaultPricicingPocRequest
  ) {
    const url = `brief/edit-default-pricing-poc`;
    return (await api
      .patch(url, {
        json: {
          ...data,
        },
      })
      ?.json()) as BackednResponse<IBrief>;
  }
  public static async editDefaultAgecnyPricicingPoc(
    data: IEditDefaultPricicingPocRequest
  ) {
    const url = `brief/edit-default-agency-pricing-poc`;
    return (await api
      .patch(url, {
        json: {
          ...data,
        },
      })
      ?.json()) as BackednResponse<IBrief>;
  }

  public static async removePricingPoc(
    data: IRemoveDefaultPricicingPocRequest
  ) {
    const url = `brief/remove-default-pricing-poc`;
    return (await api
      .delete(url, {
        json: {
          ...data,
        },
      })
      ?.json()) as BackednResponse<IBrief>;
  }

  public static async removeAgencyPricingPoc(
    data: IRemoveDefaultPricicingPocRequest
  ) {
    const url = `brief/remove-default-agency-pricing-poc`;
    return (await api
      .delete(url, {
        json: {
          ...data,
        },
      })
      ?.json()) as BackednResponse<IBrief>;
  }

  public static async getBriefNotifications(
    briefId: string,
    userId: string,
    superUserId: string,
    type: "priceReachout" | "campaignExecution" | "brief"
  ) {
    const createdBy = superUserId === userId ? [userId] : [userId, superUserId];

    const url = `brief/bulk-action/search`;
    const response = (await api
      .post(url, {
        json: {
          briefId,
          actionType:
            type === "priceReachout"
              ? [
                  BriefNotificationActionType.priceReachout,
                  BriefNotificationActionType.priceReachoutResend,
                ]
              : type === "brief"
                ? [
                    BriefNotificationActionType.analyzeCreator,
                    BriefNotificationActionType.reAnalyzeCreator,
                    BriefNotificationActionType.copyToAnotherBrief,
                    BriefNotificationActionType.setCustomColumns,
                    BriefNotificationActionType.attachDeliverables,
                    BriefNotificationActionType.purchase,
                    BriefNotificationActionType.declineBrand,
                    BriefNotificationActionType.declineInfluencer,
                    BriefNotificationActionType.assignPricingPoc,
                    BriefNotificationActionType.reallocatePricingPoc,
                    BriefNotificationActionType.removePricingPoc,
                    BriefNotificationActionType.deleteInfluencer,
                    BriefNotificationActionType.addInfluencersToBucket,
                    BriefNotificationActionType.skipConfirmation,
                    BriefNotificationActionType.resendConfirmation,
                    BriefNotificationActionType.shortlist,
                    BriefNotificationActionType.unshortlist,
                    BriefNotificationActionType.markPendingReviewAsSeen,
                    BriefNotificationActionType.addSocialMediaToBrief,
                    BriefNotificationActionType.editBriefInfluencer,
                  ]
                : [
                    BriefNotificationActionType.attachBriefToCampaignInfluencerTask,
                    BriefNotificationActionType.assignOperationsPocToCampaignInfluencer,
                    BriefNotificationActionType.editOrAddScriptToCampaignInfluencerTask,
                    BriefNotificationActionType.setCustomColumnsOnCampaignInfluencer,
                  ],

          createdBy: createdBy,
          statuses: [],
          createdByType: ["admin-user"],
        },
      })
      .json()) as BackednResponse<{ data: IBriefNotification[] }>;
    return response;
  }
  public static async getBriefNotification(
    briefId: string,
    notificationId: string
  ) {
    const url = `brief/bulk-action/search/by-id`;
    const response = (await api
      .post(url, { json: { briefBulkActionId: notificationId } })
      .json()) as BackednResponse<IBriefNotification>;
    return response;
  }

  public static async resolveBriefNotification(
    briefId: string,
    notificationId: string
  ) {
    const url = `brief/bulk-action/mark-as-resolved`;
    const response = (await api
      .put(url, {
        json: {
          briefBulkActionId: notificationId,
        },
      })
      .json()) as BackednResponse<IBriefNotification>;
    return response;
  }
  public static async deleteBriefDataFieldV2(
    briefId: string,
    customFieldId: string
  ) {
    const url = `brief/custom-fields`;
    const response = (await api
      .delete(url, {
        json: {
          briefId,
          customFieldId,
        },
      })
      .json()) as BackednResponse<IBrief>;
    return response;
  }

  public static async bulkDeclineInfluencers(
    briefInfluencerIds: string[],
    reason?: string
  ) {
    const url = `brief/influencer-v2/bulk-decline-influencer`;
    return (await api
      .put(url, {
        json: {
          decline: briefInfluencerIds.map((val) => ({
            briefInfluencerId: val,
            reason: reason || "",
          })),
        },
      })
      .json()) as BackednResponse<IBrief>;
  }

  public static async bulkDeclineBrands(
    briefInfluencerIds: string[],
    reason?: string
  ) {
    const url = `brief/influencer-v2/bulk-decline-brand`;
    return (await api
      .put(url, {
        json: {
          decline: briefInfluencerIds.map((val) => ({
            briefInfluencerId: val,
            reason: reason || "",
          })),
        },
      })
      .json()) as BackednResponse<IBrief>;
  }

  public static async bulkActionsInfluencer(payload: IBulkActionRequest) {
    const response = await api.post("brief/bulk-action/brief-influencer", {
      json: {
        ...payload,
        filterParams: mapBriefInfluencerSearchParams(payload.filterParams),
      },
    });
    return response;
  }
  public static async editCampaignDataFieldV2Data(
    campaignInfluencerId: string,
    dataField: { [key: string]: IDataFieldValue }
  ) {
    const url = `campaign/influencer/dynamic-fields/brief-influencer`;
    const response = (await api
      .post(url, {
        json: {
          campaignInfluencerId,
          dynamicFields: { ...dataField },
        },
      })
      .json()) as BackednResponse<BriefCampaignInf>;
    return response;
  }
  public static async editDataFieldV2DataBulk(
    briefInfluencerIds: string[],
    dataField: { [key: string]: IDataFieldValue }
  ) {
    const url = `brief/influencer-v2/bulk-data-fields`;
    const response = (await api
      .post(url, {
        json: {
          briefInfluencerIds,
          dataFields: { ...dataField },
        },
      })
      .json()) as BackednResponse<
      {
        briefInfluencerId: string;
        status: "failed" | "success";
        error?: Error;
        briefInfluencer: IBriefInfluencerV2;
      }[]
    >;
    return response;
  }

  public static async suggestInfluenceByUsernameBulk(
    data: ISuggestInfluencerUsernameRequest
  ) {
    const url = "bulk-action/add-influencers/brief";
    const response = await api.post(url, {
      json: {
        ...data,
      },
    });
    return response.json();
  }

  public static async updateBriefAiSettings({
    briefId,
    isCreatorFitCheckEnabled,
    brandId,
    aiOverview,
  }: {
    briefId: string;
    isCreatorFitCheckEnabled: boolean;
    brandId: string;
    aiOverview?: string;
  }) {
    const url = `brief/ai/edit-ai-fit-check-settings`;
    const response = (await api
      .patch(url, {
        json: {
          briefId,
          brandId,
          isCreatorFitCheckEnabled,
          aiOverview,
        },
      })
      .json()) as BackednResponse<IBrief>;
    return response;
  }

  public static async generateBriefAiOverview({
    briefId,
    brandId,
  }: {
    briefId: string;
    brandId: string;
  }) {
    const url = `brief/ai/generate-overview`;
    const response = (await api
      .post(url, {
        json: {
          briefId,
          brandId,
        },
      })
      .json()) as BackednResponse<IBriefAiOverviewGenerateResponse>;
    return response;
  }
  public static async reRunBriefAiFitCheck(briefInfluencerId: string) {
    const url = `brief/influencer-v2/analyze-or-re-analyze-ai-fit-check`;
    const response = (await api
      .post(url, {
        json: {
          briefInfluencerId,
        },
      })
      .json()) as BackednResponse<IBriefInfluencerV2>;
    return response;
  }

  public static async getBriefAiOverview(overviewId: string) {
    const url = `brief/ai/get-overview?briefOverviewAiGenerationId=${overviewId}`;
    const response = (await api
      .get(url)
      .json()) as BackednResponse<IBriefAiOverviewResponse>;
    return response;
  }

  public static async editAiExecutionSettings(
    payload: Partial<IAIConfiguration>
  ) {
    const url = `brief/ai/edit-ai-execution-settings`;
    const response = (await api
      .patch(url, {
        json: {
          ...payload,
        },
      })
      .json()) as BackednResponse<IBrief>;
    return response;
  }

  public static async getBriefInfluencersPurchaseStatus(
    params: IBriefInfluencerPurchaseStatusRequest
  ) {
    const url = `brief/influencer-v2/pre-check-purchase`;
    const response = (await api
      .put(url, {
        json: {
          ...params,
          filterParams: mapBriefInfluencerSearchParams(params.filterParams),
        },
      })
      .json()) as BackednResponse<{
      nextActionToTake: string;
      result: {
        status: "failed" | "success";
        reason: string;
        briefInfluencer: IBriefInfluencerV2;
      }[];
    }>;
    return response;
  }

  public static async shortlistInfluencer(briefInfluencerId: string) {
    const url = `brief/influencer-v2/bulk-shortlist`;
    const response = (await api
      .put(url, {
        json: { briefInfluencerIds: [briefInfluencerId] },
      })
      .json()) as BackednResponse<void>;
    return response;
  }
  public static async unshortlistInfluencers(briefInfluencerId: string) {
    const url = `brief/influencer-v2/bulk-unshortlist`;
    const response = (await api
      .put(url, {
        json: { briefInfluencerIds: [briefInfluencerId] },
      })
      .json()) as BackednResponse<void>;
    return response;
  }

  public static async getCampaignPendingReviewActionCounts(briefId: string) {
    const url = `campaign/influencer/facets/pending-review?briefId=${briefId}`;
    const response = (await api.get(url).json()) as BackednResponse<{
      brand: ICampaignPendingReviewActionCount;
      agency: ICampaignPendingReviewActionCount;
    }>;
    return response;
  }
}
